import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import axios from "../utils/api";
import toast from "react-hot-toast";
import { useUser } from "../hooks/useUser";

const API_URL = process.env.REACT_APP_API_URL_BASE || "http://localhost:6020/";

function Profile() {
  const { user } = useUser();

  const [showPw, setShowPw] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const getAuthHeader = () => {
    const u = JSON.parse(localStorage.getItem("user") || "{}");
    return u.accessToken ? { Authorization: `Bearer ${u.accessToken}` } : {};
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required"); return;
    }
    if (newPassword.length < 6) {
      toast.error("New password must be at least 6 characters"); return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("New passwords do not match"); return;
    }
    if (currentPassword === newPassword) {
      toast.error("New password must be different from current password"); return;
    }
    setSaving(true);
    try {
      const { data } = await axios.post(
        `${API_URL}api/auth/change-password`,
        { currentPassword, newPassword },
        { headers: getAuthHeader() }
      );
      toast.success(data.message || "Password changed successfully");
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
      setShowPw(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="container mt-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-7">
            <div className="card p-3 py-4">
              <div className="text-center">
                <img
                  src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                  alt="profile"
                  width="100"
                  className="rounded-circle"
                />
              </div>

              <div className="text-center my-3">
                <span className="bg-secondary uppercase p-1 px-4 rounded text-white">{user.role}</span>
                <h5 className="mt-4 mb-0">User Name : {user.username}</h5>

                <div className="px-4 mt-4">
                  <ul className="list-group">
                    <li className="list-group-item mb-2">E-mail : {user.email}</li>
                  </ul>
                  <ul className="list-group">
                    <li className="list-group-item mb-2">Join date : {user.createdAt.split("T")[0]}</li>
                  </ul>
                  <ul className="list-group">
                    <li className="list-group-item mb-2">Role : {user.role}</li>
                  </ul>
                </div>

                <div className="buttons mt-4">
                  <Button
                    variant={showPw ? "outline-secondary" : "outline-primary"}
                    className="px-4"
                    onClick={() => setShowPw((v) => !v)}
                  >
                    {showPw ? "Cancel" : "🔒 Change Password"}
                  </Button>
                </div>
              </div>

              {/* Change Password — inline, toggleable */}
              {showPw && (
                <div className="px-4 mt-3">
                  <hr />
                  <h6 className="mb-3">Change Password</h6>
                  <Form onSubmit={handleChangePassword} className="text-start">
                    <Form.Group className="mb-2">
                      <Form.Label className="small">Current Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="Enter current password"
                        required
                        autoFocus
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label className="small">New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Min 6 characters"
                        required
                        minLength={6}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label className="small">Confirm New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Re-enter new password"
                        required
                        minLength={6}
                        isInvalid={confirmPassword.length > 0 && newPassword !== confirmPassword}
                      />
                      <Form.Control.Feedback type="invalid">
                        Passwords do not match
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Button type="submit" variant="primary" className="w-100" disabled={saving}>
                      {saving ? <Spinner size="sm" animation="border" /> : "Update Password"}
                    </Button>
                  </Form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
